import axiosClient from "./axiosClient";

const residentialNurseService = {
  // Surgery
  getLitSurgery: async (data, param) => {
    const params = { page: param.page, limit: param.limit };
    const url = "/qlkhambenh/phau-thuat/danh-sach-benh-nhan/search";
    const response = await axiosClient.post(url, data, { params: params });
    return response.data;
  },
  getListStatusSurgery: async () => {
    const url = `/qlkhambenh/noi-tru/danh-sach-co-dinh-by-param?param=trang_thai_phau_thuat`;
    const response = await axiosClient.get(url);
    return response.data.data;
  },
  getPatientInfoById: async (id) => {
    const url = `/qlkhambenh/phau-thuat/thong-tin-benh-nhan?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data.data;
  },
  getDetailInfoById: async (id) => {
    const url = `/qlkhambenh/phau-thuat/chi-tiet-thong-tin?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data.data;
  },
  getLitSurgeryStaff: async () => {
    const url = `/qlkhambenh/phau-thuat/nhan-su-bac-si`;
    const response = await axiosClient.get(url);
    return response.data.data;
  },

  updatePatientInfoById: async (id, data) => {
    const url = `/qlkhambenh/phau-thuat/thong-tin-benh-nhan?id=${id}`;
    const response = await axiosClient.put(url, data);
    return response.data.data;
  },

  updateDetailSurgery: async (
    id: number | string,
    data: any,
    idPhieuKham?: any
  ) => {
    let url = `/qlkhambenh/phau-thuat/chi-tiet-thong-tin?id=${id}`;
    if (idPhieuKham) {
      url += `&idPhieuKham=${idPhieuKham}`;
    }
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  updateStatusSurgery: async (params) => {
    const url = `/qlkhambenh/phau-thuat/chuyen-trang-thai`;
    const response = await axiosClient.put(url, {}, { params: params });
    return response.data;
  },

  deleteSurgeryById: async (id) => {
    const url = `/qlkhambenh/phau-thuat/thong-tin-benh-nhan?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },

  getListLoaiTTT: async () => {
    const params = {
      storeId: 13,
      page: 1,
      limit: 1000,
      nhomVTYTId: 5,
      // isEmpty: null,
      isSearchThau: true,
    };
    const url = `store/VTYT-store/searchKey`;
    const res = await axiosClient.get(url, { params: params });
    return res.data;
  },

  // danh mục
  getListCatalog: async (params) => {
    const url = `/qlkhambenh/phau-thuat/danh-muc-phau-thuat`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  getCatalogById: async (id) => {
    const url = `/qlkhambenh/phau-thuat/danh-muc-phau-thuat?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data.data;
  },

  postCatalogById: async (data) => {
    const url = `/qlkhambenh/phau-thuat/danh-muc-phau-thuat`;
    const response = await axiosClient.post(url, data);
    return response.data.data;
  },

  putCatalogById: async (id, data) => {
    const url = `/qlkhambenh/phau-thuat/danh-muc-phau-thuat?id=${id}`;
    const response = await axiosClient.put(url, data);
    return response.data.data;
  },

  deleteCatalogById: async (id) => {
    const url = `/qlkhambenh/phau-thuat/danh-muc-phau-thuat?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data.data;
  },

  //Chẩn đoán trước phẫu thuật
  getDiagnoseBeforeSurgery: async () => {
    const url = `/qlkhambenh/dieu-duong-noi-tru/icd`;
    const response = await axiosClient.get(url);
    return response.data.data;
  },

  // cấu hình tờ điều trị
  getListTreatmentCatalog: async () => {
    const url = `/qlkhambenh/dm-mau-to-dieu-tri/list-dm-mau-to-dieu-tri`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postListTreatmentCatalog: async (data) => {
    const url = `/qlkhambenh/dm-mau-to-dieu-tri`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  deleteTreatmentCatalogById: async (id) => {
    const url = `/qlkhambenh/dm-mau-to-dieu-tri?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  putTreatmentCatalogById: async (data, id) => {
    console.log("🚀 ~ putTreatmentCatalogById: ~ id:", id);
    const url = `/qlkhambenh/dm-mau-to-dieu-tri?id=${id}`;
    const response = await axiosClient.put(url, data);
    return response.data.data;
  },

  //Loại tờ điều trị
  getListTypeTreatmentCatalog: async () => {
    const url = `/qlkhambenh/dm-mau-to-dieu-tri/list-dm-mau-to-dieu-tri`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTypeTreatmentCatalogById: async (id) => {
    const url = `/qlkhambenh/dm-loai-to-dieu-tri?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  postListTypeTreatmentCatalog: async (data) => {
    const url = `/qlkhambenh/dm-loai-to-dieu-tri`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },
  deleteTypeTreatmentCatalogById: async (id) => {
    const url = `/qlkhambenh/dm-loai-to-dieu-tri?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
  putTypeTreatmentCatalogById: async (data) => {
    const url = `/qlkhambenh/dm-loai-to-dieu-tri?id=${data.id}`;
    const response = await axiosClient.put(url, data);
    return response.data.data;
  },
};

export default residentialNurseService;
